<template lang="html">
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="dialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Control posterior</span>
          </v-tooltip>
          <h3 class="headline mb-0">Auditoría de sistemas</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn color="info" @click="nuevaEspecialidad">Nueva Especialidad</v-btn> -->
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-text-field
              :loading="loading"
              v-model="search"
              label="Buscar"
              single-line
              hide-details
              :append-outer-icon="loading ? 'update' : 'search'"
              @click:append-outer="searchFilterAudit"
              @change="searchFilterAudit"
            ></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
               :loading="loading"
               :headers="headers"
               :items="audits"
               rows-per-page-text="Filas por Pág"
               hide-actions
               :pagination.sync="pagination"
             >
               <template slot="items" slot-scope="props">

                 <td>{{ props.item.created_at }}</td>
                 <td>{{ props.item.email }}</td>
                 <td>{{ props.item.path }}</td>
                 <td>{{ props.item.method_controller }}</td>
                 <td>{{ props.item.query }}</td>
                 <td>{{ props.item.ip }}</td>
                 <td>{{ props.item.device }}</td>
                 <td>{{ props.item.platform }}</td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

            <div class="text-xs-center">
                <v-layout justify-center>
                  <v-flex xs8>
                    <v-card class="elevation-0">
                      <v-card-text>
                        <v-pagination
                          v-model="page"
                          :length="pages"
                        ></v-pagination>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
            </div>

          </v-card-text>
      </v-card>
    </v-flex>
     <!-- Inicio de dialogo -->
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">Seguridad</v-card-title>

        <v-card-text>
          Registro de accesos por USUARIO a las diferentes rutas que tiene el sistema.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Salir
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->
  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    name: 'specialties-view',

    computed: {
        ...mapGetters({
            authenticated: 'authCheck'
        }),
        pages () {
            return this.pagination.total
        }
    },

    mounted() {
        this.initComponent(1)
    },

    watch: {
      page(v) {
        if(this.activePagination){
          this.initComponent(v)
        }
        this.activePagination = true
      }
    },

    data () {
        return {
            audits: [],
            dialog: false,
            activePagination: false,
            loading: false,
            search: '',
            page: 0,
            pagination: {
                page: 1,
                totalItems: 0,
                rowsPerPage: 10,
                total: 0
            },
            headers: [
                { text: 'DATE', value: 'created_at', sortable: false },
                { text: 'USUARIO', value: 'email', sortable: false },
                { text: 'PATH', value: 'path', sortable: false },
                { text: 'METHOD', value: 'method_controller', sortable: false },
                { text: 'QUERY', value: 'query', sortable: false },
                { text: 'IP', value: 'ip', sortable: false },
                { text: 'DEVICE', value: 'device', sortable: false },
                { text: 'PLATAFORM', value: 'platform', sortable: false }
            ],
        }
    },

    methods: {

        async initComponent (page,search=null) {
            this.loading = true
            const url = search == null ? `/api/audits/admin/getAudits?page=${page}` : `/api/audits/admin/getAudits?page=${page}&search=${search}`
            await axios.get(url)
                .then(resp => {
                  console.log(resp)
                    this.audits = resp.data.data
                    this.page = resp.data.current_page
                    this.pagination = {
                        total: resp.data.last_page,
                        totalItems: resp.data.total,
                        rowsPerPage: resp.data.per_page,
                        page: 1
                    }
                })
                .catch(e => {
                    console.log(e.response,"error");
                })

            this.loading = false
        },

        nuevaEspecialidad() {

        },

        searchFilterAudit () {
            this.initComponent(this.page,this.search)
        }

    }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/auditoriaSistema.vue